module.exports = __webpack_public_path__ + "static/media/photo243.95e06ab2.jpg";